module.exports = __webpack_public_path__ + "fonts/display-bold.80f7429e.woff";